import {IDropdownOption} from "@fluentui/react";

export enum Status {
    Draft = 1,
    Submitted,
    InProgress,
    Postpone,
    Impossible,
    Partially,
    Responded,
    SystemClosed,
    Cancelled
}
export const _responseOptions: IDropdownOption[] = [
    { key: Status.Responded, text: "Responded" },
    { key: Status.Partially, text: "Partially responded" },
    { key: Status.Impossible, text: "Impossible to respond" },
    { key: Status.Postpone, text: "Postpone response" }
];
